export default __webpack_public_path__ + "static/media/bannerMini1.b13de3f2.jpg";